import React, { useState } from "react";
import CustomButton from "../../components/common/CustomButton";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { toast } from "react-toastify";

export default function RejectionModal({
  title,
  description,
  confirmText,
  cancelText = "Cancel",
  mutationFn, // 👈 mutation passed
  payload, // 👈 base payload (vendorId etc)
  onClose,
  refetch,
  loading: isLoading,
  actionType, // "reject" or "suspend"
}) {
  const [reason, setReason] = useState("");

  const handleConfirm = async () => {
    if (!reason.trim()) return;

    await mutationFn?.mutate(
      {
        ...payload,
        reason,
      },
      {
        onSuccess: () => {
          // Optionally, you can add a success message or refresh the data
          toast.success(
            actionType === "reject"
              ? "Vendor rejected successfully!"
              : "Vendor suspended successfully!",
          );
          onClose();
          refetch();
        },
        onError: (error) => {
          // Handle error, e.g., show a notification
          toast.error(
            error.response?.data?.message ||
              `Failed to ${actionType} vendor. Please try again.`,
          );
        },
      },
    );
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-[20px] shadow-xl w-[430px]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="py-8 text-center px-6">
          <div className="w-[70px] h-[70px] rounded-full bg-[#FDECEC] flex items-center justify-center mx-auto">
            <AiOutlineCloseCircle size={40} className="text-[#E53935]" />
          </div>

          <h2 className="text-[20px] font-semibold text-gray-900 mt-4">
            {title}
          </h2>
          <p className="text-gray-600 text-sm mt-1">{description}</p>
        </div>

        {/* Textarea */}
        <div className="mt-6 px-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Reason
          </label>

          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
            className="
              w-full resize-none rounded-xl border border-gray-300
              px-4 py-3 text-sm
              focus:outline-none focus:ring-2 focus:ring-red-400
            "
          />
        </div>

        {/* Buttons */}
        <div className="flex items-center justify-between px-6 mt-6 gap-4 pb-5">
          <button
            onClick={onClose}
            className="w-1/2 py-3 rounded-xl border border-gray-300 text-gray-800"
            disabled={isLoading}
          >
            {cancelText}
          </button>

          <CustomButton
            className="w-1/2 bg-red-600 hover:bg-red-700"
            onClick={handleConfirm}
            disabled={!reason.trim() || isLoading}
            loading={isLoading}
          >
            {confirmText}
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
